import React, { useState } from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { Link } from '@printdeal/ui-library';
import useSystemPages from '../../../hooks/useSystemPages';
import ConversationLoopLink from '../conversation-loop/ConversationLoopLink';
import {
  dispatchDataLayerEventOnDropdownOpen,
  dispatchDataLayerEventOnDropdownClose,
  dispatchDataLayerEventOnCustomerServiceClick,
} from './helpers/reseller-customer-care-navigation-events';

const DesktopCustomerCareNavigation = () => {
  const [isCustomerCareDropdownOpen, setCustomerCareDropdownOpen] = useState(false);
  const [helpCenterPage] = useSystemPages('helpCenterIndex');

  const handleCustomerCareLinkMouseEnter = () => {
    setCustomerCareDropdownOpen(true);
    dispatchDataLayerEventOnDropdownOpen();
  };

  const handleCustomerCareLinkMouseLeave = () => {
    setCustomerCareDropdownOpen(false);
    dispatchDataLayerEventOnDropdownClose();
  };

  return (
    <section
      onMouseEnter={handleCustomerCareLinkMouseEnter}
      onMouseLeave={handleCustomerCareLinkMouseLeave}
      className="pd-inline-flex pd-h-14"
    >
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <Link
        as="button"
        type="button"
        variant="secondary"
        iconBefore="customer-service"
        iconAfter={isCustomerCareDropdownOpen ? 'chevron-up' : 'chevron-down'}
      >
        {helpCenterPage.title}
      </Link>
      {isCustomerCareDropdownOpen && (
        <div className="pd-absolute pd-top-[8.4rem] pd-min-h-[5rem] pd-rounded-md pd-border-2 pd-bg-white pd-p-4 pd-shadow-md">
          <Link
            as={GatsbyLink}
            to={helpCenterPage.path}
            onClick={() => dispatchDataLayerEventOnCustomerServiceClick()}
            variant="secondary"
            iconBefore="customer-service"
          >
            <span className="pd-sr-only lg:pd-not-sr-only">{helpCenterPage.title}</span>
          </Link>
          <div className="pd-mt-2">
            <ConversationLoopLink handleCustomerCareLinkMouseLeave={handleCustomerCareLinkMouseLeave} />
          </div>
        </div>
      )}
    </section>
  );
};

export default DesktopCustomerCareNavigation;
